module.exports = "<article>\n  <img [src]=\"image\" [alt]=\"alt\" [title]=\"title\" />\n</article>\n"